import clsx from 'clsx';
import React from 'react';
import { FaIcon } from '../util/FaIcon';
import { AcButton } from '../button/AcButton';
import style from './AcDropdown.module.scss';
// https://react-bootstrap.github.io/components/dropdowns/#custom-dropdown-components
export const AcDropdownLinkToggle = React.forwardRef((props, ref) => {
    const { onClick, disableDropdownIcon, toggleClassName, toggleSize, children, ...rest } = props;
    const handleClick = (e) => {
        e.preventDefault();
        if (onClick) {
            onClick(e);
        }
    };
    return (React.createElement(AcButton, { ...rest, className: clsx(style.linkDropdown, toggleClassName), variant: "link", ref: ref, onClick: handleClick, size: toggleSize },
        children,
        !disableDropdownIcon && (React.createElement(FaIcon, { icon: "fas fa-caret-down", className: toggleSize === 'sm' ? 'ml-1' : 'ml-3', fixedWidth: true, size: "default", variant: "secondary" }))));
});
AcDropdownLinkToggle.displayName = 'AcDropdownLinkToggle';
